import { Injectable } from '@angular/core';
import { AppConfig } from '@app/models/app-config.model';
import { ConfigService } from '@app/services/config.service';
import { TranslateService } from '@ngx-translate/core';
import { IndividualConfig, ToastrService } from 'ngx-toastr';

type Severities = 'success' | 'info' | 'warning' | 'error';

@Injectable({providedIn: 'root'})
export class NotificationsService {
  constructor(private i18n: TranslateService,
              private toastr: ToastrService,
              private config: ConfigService) {
  }

  info(detail: string, summary?: string) {
    this.notify(
      'info',
      summary || this.i18n.instant('common.info'),
      detail
    );
  }

  success(detail: string, summary?: string) {
    this.notify(
      'success',
      summary || this.i18n.instant('common.success'),
      detail
    );
  }

  warn(detail: string, summary?: string) {
    this.notify(
      'warning',
      summary || this.i18n.instant('common.warning'),
      detail
    );
  }

  error(detail: string, summary?: string) {
    this.notify(
      'error',
      summary || this.i18n.instant('common.error'),
      detail
    );
  }

  deleteSuccess() {
    return this.success(this.i18n.instant('common.delete-ok'));
  }

  saveSuccess() {
    return this.success(this.i18n.instant('common.save-ok'));
  }

  saveError() {
    return this.error(this.i18n.instant('common.save-ko'));
  }

  noChange() {
    return this.info(this.i18n.instant('common.no-change'));
  }

  private notify(severity: Severities, summary: string, detail: string, config?: Partial<IndividualConfig>) {
    if (!config) {
      config = {};
    }

    const appConfig = <AppConfig>this.config.app;
    config.progressBar = appConfig.toastrProgressBar || false;
    config.closeButton = appConfig.toastrCloseButton;
    config.timeOut = appConfig.toastrTimeOut || 5000;
    config.extendedTimeOut = appConfig.toastrExtendedTimeOut || 1000;
    config.onActivateTick = appConfig.toastrOnActivateTick || true;
    this.toastr.show(detail, summary, config, `toast-${severity}`);
  }
}
